import { Sprite, PixiRef } from "@pixi/react";
export type ISprite = PixiRef<typeof Sprite>;

export type Player = {
  position: Position;
  spriteId: number;
  profile: PlayerDetails;
};

export type UserSession = {
  socialNetworkId: string;
  name: string;
  profileUrl: string;
};

export type FacebookUserProfile = {
  name: string;
  email: string;
  picture: {
    data: {
      height: number;
      is_silhouette: boolean;
      url: string;
      width: number;
    };
  };
  id: string;
};

export type AnonimousProfile = {
  name: string;
  profileUrl: string;
};

export enum GamePositionColor {
  Red = "tarjetas_rojas",
  Yellow = "yellow_cards",
  Blue = "blue_cards",
  Green = "green_cards",
}

export enum SocialNetwork {
  Facebook = "facebook",
  Anonymous = "anonymous",
}

export type UserProfile = {
  name: string;
  socialNetwork: string;
  socialNetworkId: string;
  profileUrl: string;
};

export type Position = {
  x: number;
  y: number;
  color?: GamePositionColor;
};

export type GameBoard = {
  players: Array<Player>;
};

export enum ShortCut {
  ladder,
  slide,
}
export type LinkedPosition = {
  from: number;
  to: number;
  type: string;
};

export type UserAccount = {
  userId: string;
  profileUrl: string;
  name: string;
  countryCode: string;
  country: string;
  points: number;
  ranking: number;
  socialNetwork: SocialNetwork;
  token: string;
};

export type RemoteGame = {
  gameId: string;
  expiresAt: number;
  dateTime: string;
};

export enum GameStatus {
  RollDice = "rollDice",
  AnswerQuestion = "answerQuestion",
  WaitingPlayers = "waitingPlayers",
  ReadingCard = "readingCard",
}

export enum GameMode {
  PlayAlone = "playAlone",
  PlayWithFriends = "playWithFriends",
}

export type GameDetails = {
  ownerUserId: string;
  ownerUserName: string;
  gameId: string;
  status: GameStatus;
  ttl: number;
  diceResult: Array<number>;
  cardId?: string;
  cardAnswer?: string;
  tempCardAnswer?: string;
  turnUserId: string;
  turnUserPosition?: number;
  turnUserLocation?: Position;
  turnExpAt: number;
  mode: GameMode;
};

export type UpdateGameDetails = {
  status?: GameStatus;
  diceResult?: Array<number>;
  cardId?: string;
  cardAnswer?: string;
  tempCardAnswer?: string;
  turnUserId?: string;
  turnUserLocation?: Position;
};

export type UpdatePlayerDetails = {
  boardPosition?: number;
  finishTimeStamp?: number;
  points?: number[];
  magnifyGlass?: number[];
};

export type PlayerDetails = {
  ttl: number;
  socialNetwork: SocialNetwork;
  timeStamp: number;
  gameId: string;
  userId: string;
  name: string;
  profileUrl: string;
  boardPosition: number;
  finishTimeStamp?: number;
  points?: number[];
  magnifyGlass?: number[];
  countryCode: string;
};

export type GreenCardRating = {
  cardId: string;
  gameId: string;
  userId: string;
  score: number;
  ttl: number;
};

export type CardRating = {
  cardId: string;
  gameId: string;
  userId: string;
  score: number;
};

export enum FirebaseEvent {
  NewRecord = "newRecord",
  UpdatedRecord = "updatedRecord",
  DeletedRecord = "deletedRecord",
}

export type PlayersEvent = {
  players: PlayerDetails[];
  newPlayer: PlayerDetails;
};

export type Ranking = {
  name: string;
  avatar: string;
  position: number;
  points: number;
  country: string;
  countryCode: string;
};

export type CardAnswer = {
  cardAnswer: string;
  isRight?: boolean;
};

export type GamePlayer = {
  userId: string;
  boardPosition: number;
  points: number;
  timeStamp: number;
};

export enum PositionAction {
  Slide = "slide",
  Ladder = "ladder",
}

export type RatingScore = {
  total: number;
  votes: number;
};
